module.exports = __webpack_public_path__ + "img/photo3_2.0e5c3145.jpg";